"use client";

import { BookOpen, Clock, Users, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function CoursesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-64 bg-muted animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <p className="text-muted-foreground text-sm">Impossibile caricare i corsi.</p>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground text-sm">Nessun corso disponibile.</p>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="group relative bg-card border border-border flex flex-col transition-shadow duration-200 hover:shadow-lg overflow-hidden" style={{
      borderRadius: 0
    }}>
          {}
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left z-10" />

          {}
          <div className="px-6 pt-6 pb-4 border-b border-border">
            <div className="mb-4">
              <BookOpen className="size-7" style={{
            color: "hsl(210 60% 45%)",
            strokeWidth: 1.5
          }} />
            </div>
            <h3 className="font-default text-xl font-bold leading-snug text-card-foreground" style={{
          letterSpacing: "var(--tracking-normal)"
        }}>
              {post.customFields?.wvc_corso_title || 'Corso senza titolo'}
            </h3>
          </div>

          {}
          <div className="flex flex-col flex-1 px-6 py-5 gap-4">
            <div className="flex flex-col gap-3 flex-1">
              {post.customFields?.wvc_corso_duration && <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Clock className="size-4 shrink-0" style={{
              color: "hsl(210 60% 45%)",
              strokeWidth: 1.5
            }} />
                  <span className="font-default">{post.customFields.wvc_corso_duration}</span>
                </div>}
              {post.customFields?.wvc_corso_recipients && <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Users className="size-4 shrink-0" style={{
              color: "hsl(210 60% 45%)",
              strokeWidth: 1.5
            }} />
                  <span className="font-default">{post.customFields.wvc_corso_recipients}</span>
                </div>}
              {post.customFields?.wvc_corso_delivery_method && <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Monitor className="size-4 shrink-0" style={{
              color: "hsl(210 60% 45%)",
              strokeWidth: 1.5
            }} />
                  <span className="font-default">{post.customFields.wvc_corso_delivery_method}</span>
                </div>}
            </div>

            <div className="pt-2">
              <Button asChild variant="outline" className="w-full border-border text-foreground hover:bg-accent hover:text-accent-foreground font-default font-medium" style={{
            borderRadius: 0
          }}>
                <Link to={post.link || "#"}>Scopri il Corso</Link>
              </Button>
            </div>
          </div>
        </div>)}
    </div>;
}
export default function RelatedCourses() {
  const wp_query_params = {
    post_type: "corso",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="related-courses" className="bg-background py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-16">
        {}
        <div className="mb-12">
          <h2 className="font-default text-foreground font-black uppercase tracking-wider" style={{
          fontSize: "42px",
          lineHeight: 1.1,
          letterSpacing: "0.04em"
        }}>
            Corsi Correlati
          </h2>
          <div className="mt-4 w-12 h-0.5 bg-accent" />
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "corso",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <CoursesConsumer />
        </PostsProvider>
      </div>
    </section>;
}